
class SignUpController {
  /* @ngInject */
  constructor(
    $window, $state, $location, $rootScope, Auth, AUTH_EVENTS, Session,
    urls, $http, CAPTCHA_SITE, Fb
  ) {
    this.$window = $window;
    this.$state = $state;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.Auth = Auth;
    this.urls = urls;
    this.AUTH_EVENTS = AUTH_EVENTS;
    this.Session = Session;
    this.CAPTCHA_SITE = CAPTCHA_SITE;
    this.FbService = Fb;
  }

  $onInit() {
    this.showEmailId = true;
    const user = this.Session.read('userinfo');
    this.updatePageTags();
    this.codeOk = false;
    this.codeNotOk = false;
    this.isEmailTrue = true;

    const baseURLParams =  this.$location.search();

    if (user) {
      return this.$state.go('home', this.$state.params);
    }

    this.Session.destroy();
    this.recaptuaToken = null;
    if (this.$state.params.state) {
      const stateData = JSON.parse(atob(this.$state.params.state));
      this.$state.params.client_id = stateData.client_id;
      this.$location.search().client_id = stateData.client_id;
      this.$state.params.continue = stateData.continue;
    }
    if (this.$state.params.client_id) {
      this.$window.localStorage.setItem('client_id', this.$state.params.client_id);
    }

    this.objects = [
      { object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/87212205-9631-85c5-e510-8f2dc8c3fe75.jpg', link: 'https://www.shoppre.com/personal-shopper-offers' },
      { object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/05f17920-8548-bad6-6e76-67c366747e84.jpg', link: 'https://www.shoppre.com/first-time-international-shipment-offer' },
      { object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/5710996f-4973-4170-8f22-7034780a8eda.png', link: 'https://www.shoppre.com/indian-virtual-address' },
      { object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/2e9b692f-9152-4bd1-babb-37db778234d4.png', link: 'https://www.shoppre.com/indian-virtual-address' },
    ];
    // if (this.$location.search.referral_code){
    //   this.user.referral_code = baseURL.referral_code;
    // }
    // console.log('cc', this.user.referral_code)

    if (this.$state.params.type) {
      this.$state.params.client_id = this.$state.params.client_id || this.$location.search().client_id;
    }
    if (this.$state.params.utm_source && this.$state.params.utm_source != 'undefined') {
      document.cookie = `utm_source=${this.$state.params.utm_source};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.utm_campaign && this.$state.params.utm_campaign != 'undefined') {
      document.cookie = `utm_campaign=${this.$state.params.utm_campaign};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.utm_medium && this.$state.params.utm_medium != 'undefined') {
      document.cookie = `utm_medium=${this.$state.params.utm_medium};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.original_source && this.$state.params.original_source != 'undefined') {
      document.cookie = `original_source=${this.$state.params.original_source};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.parameter_url && this.$state.params.parameter_url != 'undefined') {
      document.cookie = `parameter_url=${this.$state.params.parameter_url};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.gcl_id && this.$state.params.gcl_id != 'undefined') {
      document.cookie = `gcl_id=${this.$state.params.gcl_id};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.referrer && this.$state.params.referrer != 'undefined') {
      document.cookie = `referrer=${this.$state.params.referrer};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.first_visit && this.$state.params.first_visit != 'undefined') {
      document.cookie = `first_visit=${this.$state.params.first_visit};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.post_login_page && this.$state.params.post_login_page != 'undefined') {
      document.cookie = `post_login_page=${this.$state.params.post_login_page};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.collect_coupon && this.$state.params.collect_coupon != 'undefined') {
      document.cookie = `collect_coupon=${this.$state.params.collect_coupon};domain=${this.urls.DOMAIN};`;
    }
    const fromDomain = this.getCookie('from_domain');

    if (this.$state.params.from_domain && this.$state.params.from_domain != 'undefined') {
      document.cookie = `from_domain=${this.$state.params.from_domain};domain=${this.urls.DOMAIN};`;
    } else if (!fromDomain) {
      document.cookie = `from_domain=${this.urls.DOMAIN};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.referral_code && this.$state.params.referral_code != 'undefined') {
      document.cookie = `referral_code=${this.$state.params.referral_code};domain=${this.urls.DOMAIN};`;
    }
    // if (this.$state.params.type !== 'facebook' && this.$location.search().client_id !== 'courier-admin') {
    //   this.$window.location.href = `${this.urls.WWW}/customer/login`;
    // }

    if(this.$state.params.membershipType) {
      if (this.Session.read('member')) {
        this.Session.clear(['member']);
      }
      this.isMember = true;
      const member = {
        type: this.$state.params.membershipType,
        amount: this.$state.params.membershipAmount,
      };

      this.Session.create('member', member);
    }

    this.error = null;
    this.user = {
      username: this.$state.params.username || '',
      password: this.$state.params.password || '',
      referral_code: baseURLParams.referral_code || '',
    };

    if (this.$state.params.code
    || (this.$state.params.username && this.$state.params.password)) {
      return this.signUp(this.$state.params.code, this.$state.params.type, this.$state.params.client_id);
    }

    this.generateCaptcha();

    if (this.user.referral_code) {
      this.isReferralCodeValid();
    }

    this.show = true;
    return null;
  }
  preventSpace(event) {
    if (event.keyCode === 32) {
      event.preventDefault();
    }
  };

  checkPasswordStrength() {
    const pass = this.user.password;
    if (pass.length < 6){
      //this.dissableSubmit = true;
      this.weekPass = true;
      this.mediumPass = false;
      this.strongPass = false;
    }
    if (pass.length >= 6){
      //this.dissableSubmit = false;

      var checkContainNum = new RegExp('[0-9]');
      var checkContainSmall = new RegExp('[a-z]');
      var checkContainCapital = new RegExp('[A-Z]');
      // var checkContainSpecial = new RegExp('/\\W|_/g');

      pass.match(checkContainNum) ? this.containNumber = true : this.containNumber = false;
      pass.match(checkContainSmall) ? this.containSmallLetter = true : this.containSmallLetter = false;
      pass.match(checkContainCapital) ? this.containCapsLetter = true  : this.containCapsLetter = false;
      /\W|_/g.test(pass) ? this.containSpecialChar = true : this.containSpecialChar = false;

      if (this.containSmallLetter && this.containNumber || this.containSmallLetter && this.containCapsLetter || this.containSmallLetter && this.containSpecialChar
        || this.containCapsLetter && this.containNumber || this.containCapsLetter && this.containSpecialChar
        || this.containSpecialChar && this.containNumber
      ) {
        this.weekPass = false;
        this.mediumPass = true;
        this.strongPass = false;
      }
      if (this.containNumber = true && this.containSmallLetter && this.containCapsLetter && this.containSpecialChar) {
        this.mediumPass = false;
        this.weekPass = false;
        this.strongPass = true;
      }

    }
  }

  checkPasswordMatch() {
    if (this.user.password && this.user.confirm_password) { // Check if both fields are filled
      const password = this.user.password.toLowerCase();
      const confirmPassword = this.user.confirm_password.toLowerCase();

      if (password === confirmPassword) {
        // Passwords match
        this.passwordsMatch = true;
      } else {
        // Passwords do not match
        this.passwordsMatch = false;
      }
    } else {
      // One or both fields are empty, reset password match flag
      this.passwordsMatch = undefined;
    }
  };

  goBack() {
    this.$window.history.back();
  };

  validateEmail() {
     // Regular expression for email validation
     var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

     // Check if the email field is not empty and matches the email pattern
     if (this.user.email && emailRegex.test(this.user.email)) {
       this.showOtherFields = true;
       this.showEmailId = false;
     } else {
       this.error = 'Invalid email address. Please enter a valid email.';
     }
   }


  updatePageTags() {
    // this.$window.document.title = "Sign-Up for Free | ShoppRe™️ | Ship Internationally from India";
    var link = this.$window.document.createElement('meta');
    link.setAttribute('name', 'description');
    link.content = 'New to ShoppRe? Sign Up to send your shipment by setting up a personal account. Also, you\'ll be able to store & access all your parcel here for free';
    this.$window.document.getElementsByTagName('head')[0].appendChild(link);

    var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    this.$window.document.head.appendChild(link);
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      const data =  parts.pop().split(';').shift();
      return data == 'undefined' ? null : data;
    }
  }

  validEmail(e) {
    var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
    return String(e).search (filter) != -1;
  }

  signUp(code, type, clientId) {
    if (this.codeNotOk) {
      this.user.referral_code = null;
    }
    this.isEmailTrue = true;
    if (!this.validEmail(this.user.email)) {
      this.isEmailTrue = false;
      return;
    }
    if (this.user.password !== this.user.confirm_password) {
      this.error = 'Passwords do not match. Please enter matching passwords.';
      return;
    }
    this.error = null;
    this.show = false;
    this.user.isMember = this.isMember;
    const { username, password } = this.user;
    Object.assign(this.user, { recaptuaToken: this.recaptuaToken });

    const options = { username, password };
    const url = `${this.urls.LOGIN_APP}/api/users/public/registerVerify`;

    Object.assign(this.user, { utm_source: this.getCookie('utm_source') });
    Object.assign(this.user, { utm_medium: this.getCookie('utm_medium') });
    Object.assign(this.user, { utm_campaign: this.getCookie('utm_campaign') });
    Object.assign(this.user, { original_source: this.getCookie('original_source') });
    Object.assign(this.user, { parameter_url: this.getCookie('parameter_url') });
    Object.assign(this.user, { gcl_id: this.getCookie('gcl_id') });
    Object.assign(this.user, { from_domain: this.getCookie('from_domain') });
    Object.assign(this.user, { referrer: this.getCookie('referrer') });
    Object.assign(this.user, { first_visit: this.getCookie('first_visit') });
    Object.assign(this.user, { collect_coupon: this.getCookie('collect_coupon') });

    this.$http.post(url, this.user)
      .then(({ data }) => {
        this.show = true;
        if (data.message === 'invalid_captcha') {
          this.error = 'Invalid captcha';
          return;
        }
        if (data.message === 'Already User Is Registered, Please Verify Your email To Continue') {
          this.error = 'Already User Is Registered, Please Sign in';
          return;
        }
        const customerData = {};

        this.FbService.eventEmitter('Lead', customerData);
        if (this.isMember) {
          return this.signin();
        }
        this.signin();
        // let continueUrl = this.getCookie('post_login_page');
        // continueUrl = continueUrl ? continueUrl : this.$state.params.continue;
        // this.$state.go('oauth.signin', {
        //   message: data.message,
        //   client_id: this.$state.params.client_id,
        //   continue: this.$state.params.continueUrl
        // });
      })
      .catch(() => {
          this.error = 'An unexpected error occurred. Please try again.';
          this.show = true;
        });
  }

  signin(code, type, clientId) {
    this.error = null;
    this.show = false;

    const { email: username, password } = this.user;

    let options = {};
    options = {
      username,
      password,
    }

    // Try to login
    this.Auth
      .login(options)
      .then(() => {
        this.$rootScope.$broadcast(this.AUTH_EVENTS.loginSuccess);
        this.Auth
          .setSessionData()
          .then(() => {
            const { $location, $state } = this;
            const user = this.Session.read('userinfo');
            if (user) {
              if (!user.is_email_verified && user.email.includes('@shoppre.com')) {
                this.message = 'Verify your account to login';
                this.$window.localStorage.clear();
                return $state.go('oauth.signin', { message: this.message });
              }
            }
            const { whatBlocked = [] } = this.Session.read('userinfo') || {};
            const [state] = whatBlocked.map((x) => x.state);
            if (state === 'password-change') return $state.go(state);

            const stateOptions = {};
            if (![undefined, 'undefined', null].includes(this.$location.search().client_id)) {
              stateOptions.client_id = this.$location.search().client_id;
            }
            let continueUrl = this.getCookie('post_login_page');
            if (continueUrl) {
              this.$location.search().continue = continueUrl;
              stateOptions.continue = continueUrl;
            } else if ($location.search().continue) {
              stateOptions.continue = this.$location.search().continue;
            }
            if (!stateOptions.client_id && $location.search().client_id) {
              stateOptions.client_id = this.$location.search().client_id;
            }
            stateOptions.first_time_user = true;

            return $state.go('oauth.signin', stateOptions);
          });
      }, ({ data }) => {
        this.show = true;
        this.$rootScope.$broadcast(this.AUTH_EVENTS.loginFailed);
        this.error = data.error_description;
      });
  }

  generateCaptcha() {
    const that = this;
      grecaptcha.ready(function () {
        grecaptcha.execute(that.CAPTCHA_SITE.KEY,
          { action: 'signup' }).then(function (token) {
            that.recaptuaToken = token;
          });
      });
  }

  isReferralCodeValid() {
    this.referralSubmitting = true;
    const referralCodeForSubmit = this.user.referral_code;
    const url = `${this.urls.REFERRAL}/api/users/checkReferral?referral_code=${referralCodeForSubmit}`
    this
      .$http
      .get(url)
      .then(({ data }) => {
        data ? this.codeOk = true : this.codeOk = false;
        !data ? this.codeNotOk = true : this.codeNotOk = false;
        this.referralSubmitting = false;
      })
      .catch((err) => {
        this.codeNotOk = true;
        this.referralSubmitting = false;
      });
  }


  socialRedirect(type) {
    let url = '';
    let continueUrl = this.getCookie('post_login_page');
    continueUrl = continueUrl ? continueUrl : this.$location.search().continue;
    const referralCode = this.$location.search().referral_code;
    if (type === 'google') {
      url = `${this.urls.LOGIN_APP}/api/oauth/google?continue=${continueUrl}&client_id=${this.$location.search().client_id}&type=register`;
    } else {
      url = `${this.urls.LOGIN_APP}/api/oauth/facebook?continue=${continueUrl}&client_id=${this.$location.search().client_id}&type=register`;
    }
    // this.$window.location.href = url;
    this.$http.get(url).then(({ data }) => {
      this.$window.location.href = data.redirectUrl;
    });
  }
}

export default SignUpController;



// WEBPACK FOOTER //
// ./client/app/oauth/sign-up/sign-up.controller.js